export default "__VITE_ASSET__VPIm0TIZ__"